import React from 'react';
import { func, string, object, bool } from 'prop-types';
import PageSelector from './PageSelector';

import CSS from './styles.css';

const MenuViews = props => {
  return (
    <section className={ CSS['container'] }>
      <div className={ CSS['filler'] }></div>
      <nav role="navigation" aria-label="Menu Navigation">
        <ul className={ CSS['list'] }>
          <li className={ props.ebookListItem } onClick={ props.toggle } onKeyDown={ props.toggle } tabIndex="0">
            <div className={ props.ebookTabItem }>
              <span>eBOOK</span>
            </div>
          </li>
          <li className={ props.notebookListItem } onClick={ props.toggle } onKeyDown={ props.toggle } tabIndex="0">
            <div className={ props.notebookTabItem }>
              <span>NOTEBOOK</span>
            </div>
          </li>
          { props.activeMenu === 'eBOOK' 
            && props.showPageSelector &&
              <li className={ props.pageNumberListItem } tabIndex="0">
                <div className={ props.pageNumberTabItem }>
                  <PageSelector />
                </div>
              </li>
          }
        </ul>
      </nav>
      <div className={ CSS['filler-hide-xs'] }></div>
    </section>
  );
};

MenuViews.propTypes = {
  ebookTabItem: string,
  notebookTabItem: string,
  notebookListItem: string,
  pageNumberListItem: string,
  pageNumberTabItem: string,
  toggle: func,
  activeMenu: string,
  showPageSelector: bool
};


export default MenuViews;
